<template lang="pug">
  div
    v-data-table(
      :items="expenses"
      :headers="headers"
      hide-default-footer
      dense
    )
      template(v-slot:body.append)
        tr
          th(colspan="3") Total
          td.text-right {{ totalCost.phpFormat() }}
          td &nbsp;
      template(v-slot:item="{ item, index }")
        tr
          td {{ ((item.expense_category || {}).description || 'N/A') }}
          td {{ item.description }}
          td {{ (item.date || '').dateFormat() }}
          td.text-right {{ Number(item.cost || 0).phpFormat() }}
          td
            base-tooltip(
              color="error"
              tooltip="delete"
              dark
              x-small
              text
              bottom
              @click="removeItemFromExpense(index)"
            )
              v-icon mdi-delete

</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseRepository from '@/repositories/expense.repository'
import { mapState, mapActions } from 'vuex'

const tableVars = () => ({
  headers: [
    { text: 'Category', value: 'expense_category_id' },
    { text: 'Description', value: 'description' },
    { text: 'Date', value: 'date' },
    { text: 'Cost', value: 'cost', align: 'right' },
    { text: 'Config', sortable: false },
  ],
})

export default {
  name: 'TableExpenses',
  data: () => ({
    ...tableVars(),
  }),
  computed: {
    ...mapState({
      expenses: state => state.expense.list,
    }),
    totalCost() {
      return this.expenses.reduce((total, item) => total + item.cost, 0)
    },
  },
  methods: {
    ...mapActions({
      removeItemFromExpense: 'expense/removeItemFromList',
    }),
  },
}
</script>
